import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import socketService from '../services/socket';
import './JoinRoom.css';

const JoinRoomPublic = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [userName, setUserName] = useState('');
  const [roomInfo, setRoomInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) return;
    
    // Si l'utilisateur est connecté, rediriger directement vers la salle d'attente
    if (user) {
      navigate(`/rooms/${roomId}/waiting`);
      return;
    }
    
    // Sinon, charger les infos de la room via socket pour afficher le nom
    loadRoomInfo();
  }, [roomId, user, loading, navigate]);

  const loadRoomInfo = async () => {
    try {
      const response = await socketService.getRoomInfo(roomId);
      setRoomInfo(response.room);
      setError('');
    } catch (err) {
      // Silently fail - room may not exist yet, user can still join
      setRoomInfo(null);
    }
  };

  const handleJoinWaitingRoom = async (e) => {
    e.preventDefault();
    if (!userName.trim()) {
      setError('Veuillez entrer votre nom');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await socketService.joinWaitingRoom(roomId, userName);
      sessionStorage.setItem(`waitingRoomName_${roomId}`, userName);
      navigate(`/rooms/${roomId}/waiting`);
    } catch (err) {
      setError(err.message || 'Erreur lors de la demande');
    } finally {
      setIsLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="join-room-page">
        <div className="join-room-card">
          <div className="loading">Chargement...</div>
        </div>
      </div>
    );
  }

  if (error && !roomInfo) {
    return (
      <div className="join-room-page">
        <div className="join-room-card">
          <div className="error-icon">❌</div>
          <h2>Erreur</h2>
          <p>{error}</p>
          <button className="btn-primary" onClick={() => navigate('/')}>
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="join-room-page">
      <div className="join-room-card">
        <div className="invitation-icon">📧</div>
        <h2>Rejoindre une réunion</h2>
        
        {roomInfo && (
          <div className="room-preview">
            <h3>{roomInfo.name || roomInfo.title || 'Réunion'}</h3>
          </div>
        )}

        <form onSubmit={handleJoinWaitingRoom}>
          <div className="input-group">
            <label htmlFor="userName">Votre nom</label>
            <input
              id="userName"
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Entrez votre nom"
              disabled={isLoading}
              required
            />
          </div>
          
          <div className="join-actions">
            <button 
              type="submit"
              className="btn-primary btn-large"
              disabled={isLoading}
            >
              {isLoading ? 'Connexion...' : 'Rejoindre la salle d\'attente'}
            </button>
            <button 
              type="button" 
              className="btn-secondary" 
              onClick={() => navigate('/')}
            >
              Annuler
            </button>
          </div>
          
          {error && <div className="error-message">{error}</div>}
        </form>
        
        <div className="login-hint">
          <p>Déjà inscrit ? <button onClick={() => navigate('/login', { state: { from: `/join/${roomId}` } })}>Connectez-vous</button></p>
        </div>
      </div>
    </div>
  );
};

export default JoinRoomPublic;